// Condo form rules. The address is required (it is placed on the map by the
// backend, 422 `address_not_found` when it cannot be).

const NAME_MAX = 120;

export function emptyCondo() {
  return { name: '', address: '', description: '', active: true };
}

export function condoToForm(condo) {
  return {
    name: condo.name,
    address: condo.address,
    description: condo.description || '',
    active: !!condo.active,
  };
}

// Returns { field: CODE } with the codes of CO_LIVING.CONDOS.ERRORS.
export function validateCondo(form) {
  const errors = {};
  const name = form.name.trim();
  if (!name || name.length > NAME_MAX) errors.name = 'NAME';
  if (!form.address.trim()) errors.address = 'ADDRESS';
  return errors;
}

// Create takes `active`; on edit the archive/restore switch is its own call
// (PUT /condos/{id}/active), so the update body has only the three fields.
export function condoPayload(form, { isEdit }) {
  const body = {
    name: form.name.trim(),
    address: form.address.trim(),
    description: form.description.trim(),
  };
  return isEdit ? body : { ...body, active: form.active };
}

// A stable pastel from the id, for the header image of a condo.
export function condoHue(id) {
  let hue = 0;
  String(id)
    .split('')
    .forEach(ch => {
      hue = (hue * 31 + ch.charCodeAt(0)) % 360;
    });
  return hue;
}
